module.exports = __webpack_public_path__ + "static/media/2.53959b6f.png";